import { createStore } from 'owa-satcheljs';
import type AppBackgroundStore from './schema/AppBackgroundStore';

export const getAppBackgroundStore: () => AppBackgroundStore = createStore<AppBackgroundStore>(
    'appBackground',
    {
        image: undefined,
        backgroundColor: 'transparent',
    }
);

export default getAppBackgroundStore;
